import { ReactElement, useEffect } from 'react';
import { setGlobalLoadingEnabled } from './global-loading-slice';
import { useAppDispatch } from '@/app/hooks';

const DisableGlobalLoading = (): ReactElement | null => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setGlobalLoadingEnabled({ enabled: false }));

    return () => {
      dispatch(setGlobalLoadingEnabled({ enabled: true }));
    };
  }, [dispatch]);

  return null;
};

export default DisableGlobalLoading;
